module.exports = __webpack_public_path__ + "img/undraw_camping_noc8.d0b68e18.svg";